import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { propertiesApi as n } from "@maat/api-main";
//#region src/properties/usePropertyDetailQuery.ts
var r = (r) => t({
	queryKey: e.property(r),
	queryFn: () => n.getPropertyDetail(r)
});
//#endregion
export { r as usePropertyDetailQuery };
